module.exports = __webpack_public_path__ + "static/better-broker-desk-bkgrd-3dbd29e46fd7b7e3c755643bef5c3da4.png";